import { media } from '@atlaskit/primitives/responsive';
import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';
import { useLoaderData } from 'react-router-dom';
import { Divider } from '@atlassian/learning-components';

import { useScreenEvent } from 'src/hooks/useScreenEvent';

import { Content } from './Content';
import { InstructorIntro } from './InstructorIntro';
import { Props as LoaderProps } from './loader';
import { UpperSection } from './children/UpperSection';
import { LowerSection } from './children/LowerSection';

export const ClassPage = () => {
  const { iltData, session } = useLoaderData() as LoaderProps;

  useScreenEvent({ eventName: 'classPageScreen' });

  return (
    <>
      <div css={headerContainerStyles}>
        <UpperSection
          title={iltData?.courseTitleExternal || ''}
          duration={iltData?.duration ? `${iltData.duration} hours` : ''}
          location="Online - Remote Training (Live Instructor)"
          isFree={true}
          products={['JIRA', 'Confluence']}
        />
        <Divider color={token('color.border')} />
        <LowerSection {...session} courseName={iltData?.courseTitleExternal || ''} isFree={true} />
        <Divider color={token('color.border')} />
      </div>
      <div css={contentContainerStyles}>
        <Content iltData={iltData} />
        <InstructorIntro instructor={iltData?.instructor} />
      </div>
    </>
  );
};

const headerContainerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: token('space.400'),
  width: '100%',
  paddingBottom: token('space.400'),
});

const contentContainerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: token('space.400'),

  [media.above.sm]: {
    flexDirection: 'row',
    gap: token('space.300'),
  },
});
